export type AttentionRow = {
  needs_attention?: boolean | null;
  payment_needs_attention?: boolean | null;
  compliance_issue_status?: string | null;
};

export type AttentionColumnParts = {
  payment: boolean;
  compliance: boolean;
  readyForCheck: boolean;
  labels: string[];
  value: string;
};

export function attentionColumnParts(
  row: AttentionRow,
  includeReadyForCheck = false,
): AttentionColumnParts {
  const status = row.compliance_issue_status ?? null;
  const compliance = status === "OPEN" || status === "PENDING_CHECK";
  const payment =
    row.payment_needs_attention ??
    (Boolean(row.needs_attention) && !compliance);
  const readyForCheck = includeReadyForCheck && status === "PENDING_CHECK";
  const labels: string[] = [];
  if (payment) labels.push("Needs Attention");
  if (compliance) labels.push("Compliance Issue");
  if (readyForCheck) labels.push("Ready for Check");
  return {
    payment,
    compliance,
    readyForCheck,
    labels,
    value: labels.length > 0 ? labels.join(", ") : "No",
  };
}
